/* Winterfeldt – gezeichnete Animation (Geschichte-Section).
   Portiert aus Claude Design (winterfeldt-draw.jsx), ohne React.
   Die Zeichnung (wf-ink.webp) wird entlang von 268 Strichketten
   Zelle fuer Zelle freigelegt: 7,6 s zeichnen, 3,4 s halten, Schleife. */
(function () {
  'use strict';
  if (window.__wfDrawLoaded) return;
  window.__wfDrawLoaded = true;

  var W = 1126, H = 1397, CELL = 22, BLEED = 1.6;
  var DRAW = 7.6, HOLD = 3.4, TIP = 0.11;
  var DIRS = [[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1],[1,-1]];
  var DATA = '42.47.0212222.316.949;0.56.00.1000.0;28.31.1222.243.970;33.23.112222.316.949;25.12.6100.1000.0;33.15.122222.164.986;25.22.0000.1000.0;25.16.22222.0.1000;25.35.666666.0.-1000;18.29.666677.316.-949;37.26.11110111111.740.673;40.38.2221143344444452222222222.-447.894;31.5.222222222222222222222222222222222.0.1000;26.35.76666076.394.-919;22.27.666676666656666666666.0.-1000;3.56.65666666.-124.-992;15.41.766666666666666666666666665.0.-1000;37.22.22.0.1000;45.57.0000.1000.0;0.48.7000000007100.997.-77;46.40.7012021.857.514;18.21.776664.196.-981;4.52.7665.0.-1000;18.30.776666.316.-949;0.44.766707717.759.-651;29.12.5666.-243.-970;0.47..0.0;33.9.1222.243.970;20.9.22234.-447.894;28.7.34422.-707.707;14.14.7.707.-707;25.28.000.1000.0;25.36.070.949.-316;9.59.10.894.447;7.59..0.0;45.46..0.0;36.13.11211122177720112.768.640;0.40.66.0.-1000;47.27.676767.447.-894;18.33.0022222210.496.868;33.10.222.0.1000;49.21.6654546760.-275.-962;14.36.66.0.-1000;36.59.000.1000.0;29.45.2.0.1000;25.45.2000.949.316;5.23.66677777777677777770700000000.781.-625;46.35.76.447.-894;17.59..0.0;8.60.66667767776.414.-910;40.31.5556.-600.-800;5.48.01223.243.970;16.52.660056.243.-970;26.2.0.1000.0;9.54.660606566700.447.-894;17.47.000.1000.0;2.57.000706666.707.-707;34.25.3221.0.1000;45.51.666.0.-1000;26.16.00.1000.0;34.53.66767.371.-928;41.28.01112.707.707;37.46.344222.-600.800;47.51.122234.-196.981;46.28.0077.894.-447;36.14.21111.625.781;8.43.677076.625.-781;47.47.322220223.-124.992;19.59.6.0.-1000;4.38.44566666676677777077770.428.-904;34.32.12.447.894;29.31.6.0.-1000;11.58.66617005666666666770.371.-928;29.17.2222.0.1000;26.39.0000000011111102221222221.728.685;45.40.200122212.496.868;9.51.777.707.-707;49.45.66.0.-1000;42.34.111211111.664.747;6.50.23.-447.894;42.48.322.-316.949;6.57..0.0;33.16.2222.0.1000;1.29.667707766777777677776.600.-800;35.42.455434443464466666666666666666656.-526.-850;23.44.2.0.1000;33.32.21216322102.351.936;9.56.2021701077077776666666665000000000000100.914.-406;33.34.7.707.-707;46.16.0.1000.0;34.46.0012122221100.664.747;47.44..0.0;23.13.222322.-164.986;22.5.0222.316.949;4.40.34223.-600.800;20.59.000066760.832.-555;19.12.66.0.-1000;11.53.21111170.814.581;5.29.777776770.707.-707;25.44.0000.1000.0;3.54.00.1000.0;18.20.666566666666077770000000000111211211121121.999.-40;17.39.72065676.371.-928;25.51.666.0.-1000;26.48.212111121116600000700022.862.507;19.37.656.-316.-949;25.59..0.0;25.54.6.0.-1000;47.15..0.0;32.5.2111211123311112132211444332210022220001.351.936;18.10.7.707.-707;29.59..0.0;46.53.211.555.832;42.33.110110.832.555;26.59..0.0;16.49.66607700.707.-707;46.23.3122.0.1000;28.59..0.0;37.49.2222434.-514.857;46.37.7705676766656.243.-970;27.59..0.0;13.16.2.0.1000;12.25.132211.316.949;41.38.1221142300010110.669.743;8.41.777.707.-707;7.30.556677.0.-1000;39.22.3.-707.707;41.54..0.0;38.38.2221110.555.832;46.43..0.0;25.52.0.1000.0;39.14.2121111.581.814;2.35.767777677567567670765.410.-912;35.37..0.0;1.39.67776656056657.152.-988;9.21.77707066.707.-707;18.41.00001.981.196;27.21.6667.243.-970;14.23.6667.243.-970;42.58.6.0.-1000;13.52.6567.0.-1000;36.20.021122207070.894.447;3.46.6666.0.-1000;10.37..0.0;18.40..0.0;22.39..0.0;8.48..0.0;7.48..0.0;43.32.210.707.707;7.45.00070007120170.1000.0;44.27.660.447.-894;4.55.07.894.-447;4.46.777666670076.573.-819;5.30.10.894.447;19.55..0.0;29.42.44554.-928.-371;36.10..0.0;42.37.0.1000.0;36.52..0.0;10.34.7661.707.-707;6.20.7777.707.-707;45.44.67454356675455.-614.-789;15.10..0.0;33.6..0.0;14.11..0.0;20.5..0.0;50.40.65667666655444666.-336.-942;19.6..0.0;18.7..0.0;35.38..0.0;23.53.22222.0.1000;41.29.011.832.555;34.7..0.0;40.28.3112221.275.962;27.11.66.0.-1000;42.24.70070.928.-371;31.52.2212177000111.857.514;15.30.556544321223223224354477677767.-986.-164;3.48..0.0;26.31..0.0;11.41.7765.243.-970;48.40.7.707.-707;20.46..0.0;42.26.12.447.894;9.39..0.0;17.52.7756.243.-970;18.52..0.0;6.42.66.0.-1000;26.40.000011010010.949.316;10.25.7711057666.707.-707;13.42.57.0.-1000;5.33.10010071.970.243;35.53.6.0.-1000;6.27..0.0;20.40..0.0;24.54..0.0;35.56.00075.832.-555;25.57..0.0;32.41.7101171.962.275;11.21.1311102223322232102214334.0.1000;26.29.00.1000.0;5.42.2013200.600.800;8.29..0.0;10.33..0.0;29.54.23214444.-707.707;5.46.56667.0.-1000;14.58.707767.707.-707;27.57.6665065676.0.-1000;49.28..0.0;41.17..0.0;43.22.007756102.928.-371;38.31.6.0.-1000;13.22..0.0;9.58.1.707.707;43.51.66.0.-1000;8.44.00.1000.0;37.35.121222.316.949;26.18.71.1000.0;34.28.6656.-243.-970;7.33.776.555.-832;26.9..0.0;35.58.000002.981.196;15.45..0.0;13.45..0.0;2.34.666.0.-1000;32.58.5.-707.-707;20.56.77.707.-707;49.29..0.0;21.52..0.0;21.53..0.0;21.45.2.0.1000;19.49..0.0;44.42..0.0;12.57.0700.970.-243;4.56.07.894.-447;20.42.433.-832.555;12.33..0.0;44.44..0.0;26.57..0.0;6.37.7.707.-707;20.15.431221.0.1000;18.24.12221.371.928;9.43.0000070001070.997.-77;20.48.222225344300211170.217.976;22.55.2.0.1000;29.57..0.0;20.57.10.894.447;11.48..0.0;41.35..0.0;26.17..0.0;14.27.2334.-707.707;5.36.70.894.-447;41.57..0.0;31.58..0.0;11.25..0.0;8.33..0.0;21.56..0.0;30.55..0.0;18.44..0.0;26.56..0.0;44.33..0.0;11.39..0.0;39.31..0.0;16.55..0.0;28.19.22.0.1000;25.47.0000222223221022200.504.864;11.34..0.0;6.36..0.0';
  var NS = 'http://www.w3.org/2000/svg';
  var uid = 0;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function easeOutQuad(t) { return t * (2 - t); }

  function decode() {
    return DATA.split(';').map(function (part, i) {
      var f = part.split('.');
      var x = +f[0], y = +f[1], cells = [[x, y]];
      for (var k = 0; k < f[2].length; k++) {
        var s = DIRS[+f[2][k]]; x += s[0]; y += s[1]; cells.push([x, y]);
      }
      var cx = 0, cy = 0;
      cells.forEach(function (p) { cx += p[0]; cy += p[1]; });
      cx = (cx / cells.length + 0.5) * CELL; cy = (cy / cells.length + 0.5) * CELL;
      var prefix = [''], d = '', sz = (CELL + BLEED * 2).toFixed(1);
      cells.forEach(function (p) {
        d += 'M' + (p[0] * CELL - BLEED).toFixed(1) + ' ' + (p[1] * CELL - BLEED).toFixed(1) +
             'h' + sz + 'v' + sz + 'h-' + sz + 'z';
        prefix.push(d);
      });
      return { i: i, cells: cells, len: cells.length, dir: [+f[3] / 1000, +f[4] / 1000], centre: [cx, cy], prefix: prefix };
    });
  }

  // Reihenfolge "von unten" + Rhythmus: der Stift verweilt auf langen Linien
  // und pausiert, wenn er ueber das Blatt springt.
  function order(chains) {
    var list = chains.slice().sort(function (a, b) {
      return b.centre[1] - a.centre[1] || a.centre[0] - b.centre[0];
    });
    var prev = null, cursor = 0;
    list.forEach(function (ch) {
      var jump = prev ? Math.hypot(ch.centre[0] - prev[0], ch.centre[1] - prev[1]) : 0;
      var weight = 1 + (jump > 150 ? 1.8 : jump > 70 ? 0.7 : 0) + (ch.len > 12 ? 0.9 : ch.len > 6 ? 0.35 : 0);
      ch.startRaw = cursor; cursor += weight; prev = ch.centre;
    });
    list.forEach(function (ch) {
      ch.s = (ch.startRaw / cursor) * 0.94;
      ch.dur = (0.10 + 0.024 * ch.len) / Math.max(0.8, DRAW);
    });
    return list;
  }

  var CHAINS = null;

  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  function gradient(defs, id, x1, y1, x2, y2) {
    var g = el('linearGradient', { id: id, x1: x1, y1: y1, x2: x2, y2: y2 }, defs);
    var stops = [
      el('stop', { offset: 0, 'stop-color': '#fff', 'stop-opacity': 1 }, g),
      el('stop', { offset: 0, 'stop-color': '#fff', 'stop-opacity': 1 }, g),
      el('stop', { offset: 0, 'stop-color': '#fff', 'stop-opacity': 0 }, g),
      el('stop', { offset: 1, 'stop-color': '#fff', 'stop-opacity': 0 }, g)
    ];
    return stops;
  }

  function mount(root) {
    if (root.__wfDraw) return;
    root.__wfDraw = true;
    if (!CHAINS) CHAINS = order(decode());
    var id = 'wfd' + (++uid);

    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, preserveAspectRatio: 'xMidYMid meet', 'aria-hidden': 'true' });
    svg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block';
    var defs = el('defs', {}, svg);
    var mask = el('mask', { id: id + '-m', maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: W, height: H }, defs);
    el('rect', { x: 0, y: 0, width: W, height: H, fill: '#000' }, mask);

    var nodes = CHAINS.map(function (ch) {
      var path = el('path', { d: '', fill: '#fff' }, mask);
      var gid = id + '-t' + ch.i;
      var stops = gradient(defs, gid, 0.5 - ch.dir[0] * 0.5, 0.5 - ch.dir[1] * 0.5, 0.5 + ch.dir[0] * 0.5, 0.5 + ch.dir[1] * 0.5);
      var tip = el('rect', { width: CELL + BLEED * 2, height: CELL + BLEED * 2, fill: 'url(#' + gid + ')', display: 'none' }, mask);
      return { ch: ch, path: path, tip: tip, stops: stops, done: -1 };
    });
    var sweepStops = gradient(defs, id + '-sw', 0, 0, 0, 1);
    var sweep = el('rect', { x: 0, y: 0, width: W, height: H, fill: 'url(#' + id + '-sw)', display: 'none' }, mask);

    el('image', { href: root.getAttribute('data-ink'), x: 0, y: 0, width: W, height: H, mask: 'url(#' + id + '-m)' }, svg);
    root.appendChild(svg);

    function render(progress) {
      nodes.forEach(function (n) {
        var ch = n.ch;
        var q = easeOutQuad(clamp((progress - ch.s) / ch.dur, 0, 1));
        var done = q <= 0.0005 ? 0 : Math.min(ch.len, Math.floor(q * ch.len + 1e-6));
        if (done !== n.done) { n.path.setAttribute('d', ch.prefix[done]); n.done = done; }
        if (q > 0.0005 && done < ch.len) {
          var frac = clamp(q * ch.len - done, 0, 1);
          var f = Math.max(0.05, TIP), edge = frac * (1 + f);
          var c = ch.cells[done];
          n.tip.setAttribute('x', c[0] * CELL - BLEED);
          n.tip.setAttribute('y', c[1] * CELL - BLEED);
          n.stops[1].setAttribute('offset', clamp(edge - f, 0, 1));
          n.stops[2].setAttribute('offset', clamp(edge, 0, 1));
          n.tip.setAttribute('display', 'inline');
        } else {
          n.tip.setAttribute('display', 'none');
        }
      });
      // letzter Durchgang: faengt die feinsten Striche ein
      var sw = clamp((progress - 0.9) / 0.1, 0, 1);
      if (sw > 0.001) {
        var e = sw * 1.12;
        sweepStops[1].setAttribute('offset', clamp(e - 0.12, 0, 1));
        sweepStops[2].setAttribute('offset', clamp(e, 0, 1));
        sweep.setAttribute('display', 'inline');
      } else {
        sweep.setAttribute('display', 'none');
      }
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { render(1); return; }

    var total = DRAW + HOLD, elapsed = 0, last = null, running = false, raf = 0;
    function frame(now) {
      if (!running) return;
      if (last != null) elapsed = (elapsed + (now - last) / 1000) % total;
      last = now;
      render(elapsed < DRAW ? elapsed / DRAW : 1);
      raf = requestAnimationFrame(frame);
    }
    function play() { if (running) return; running = true; last = null; raf = requestAnimationFrame(frame); }
    function pause() { running = false; cancelAnimationFrame(raf); }

    render(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? play() : pause(); });
      }, { threshold: 0.15 }).observe(root);
    } else {
      play();
    }
  }

  function boot() { document.querySelectorAll('[data-wf-draw]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
